const dates = [
  'Pazartesi',
  'Salı',
  'Çarşamba',
  'Perşembe',
  'Cuma',
  'Cumartesi',
  'Pazar'
]

const months = [
  'Ocak',
  'Şubat',
  'Mart',
  'Nisan',
  'Mayıs',
  'Haziran',
  'Temmuz',
  'Ağustos',
  'Eylül',
  'Ekim',
  'Kasım',
  'Aralık'
]

export const getDay = date => {
  return dates[date.getDay()]
}

export const getMonth = date => {
  return months[date.getMonth()]
}

export const getYear = date => {
  return date.getFullYear()
}

export const formatDate = str => {
  const date = new Date(str)
  return `${date.getDate()} ${getMonth(date)} ${getYear(date)}, ${getDay(date)}`
}

export const getTotalDays = (start, end) => {
  const startDate = new Date(start)
  const endDate = new Date(end)
  const diff = Math.abs(startDate.getTime() - endDate.getTime())
  return Math.ceil(diff / (1000 * 60 * 60 * 24))
}
